<!--
 * @Author: mzw
 * @Date: 2022-03-28 13:16:04
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2024-03-05 16:45:17
 * @Description: 发票申请单
-->
<template>
  <div class="home_page" style="width: 100%;">
    <div class="spare_add_page">
      <!-- 面包屑组件 -->
      <div class="page_detail column">
        <div class="form-item top-info">
          <h2>发票申请单</h2>
          <el-button @click="save" type="primary" size="small">保存</el-button>
          <el-badge
            class="ossIdsLen"
            :value="dataForm.ossIds.length > 0 ? dataForm.ossIds.length : null"
          >
            <el-button @click="ossIdsVisible = true" size="small"
              >上传附件</el-button
            >
          </el-badge>
          <!-- <el-button @click="showMore = !showMore" size="small"
            >{{ showMore ? '只看明细' : '展开全部'
            }}<i :class="showMore ? 'el-icon-top' : 'el-icon-bottom'"></i
          ></el-button> -->
        </div>
        <el-form
          class="form-wrap"
          :model="detailInfo"
          ref="dataForm"
          :rules="detailInfoRule"
          label-width="130px"
          label-position="right"
        >
          <div class="base_info box_distance">
            <h2 class="title required">发票抬头</h2>
            <el-row>
              <el-col>
                <el-form-item label="公司名称：">
                  <el-select
                    :disabled="true"
                    v-model="detailInfo.companyId"
                    style="width: 228px"
                  >
                    <el-option
                      v-for="(item, index) in companyAccountInfo"
                      :key="index"
                      :value="item.companyId"
                      :label="item.companyName"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="票面备注:" prop="thirdInvoiceRemark">
                  <el-input
                    type="textarea"
                    maxlength="500"
                    v-model="detailInfo.thirdInvoiceRemark"
                    placeholder="请输入备注(不超过500字)..."
                    style="width: 600px !important"
                    :rows="3"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="(客户)开票要求:" prop="custRemark">
                  <el-input
                    type="textarea"
                    maxlength="500"
                    v-model="detailInfo.custRemark"
                    placeholder="请输入备注(不超过500字)..."
                    style="width: 600px !important"
                    :rows="3"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="address_info box_distance">
            <h2 class="title required">
              收票地址：
              <div class="addBtn-box" @click="addAddress">
                <img src="@/assets/img/order/addBtn.png" />新增收票地址
              </div>
            </h2>
            <el-row>
              <el-col :span="8">
                <el-form-item label="收件人公司:" prop="custReceiveCompany">
                  <el-input
                    maxlength="100"
                    v-model="detailInfo.custReceiveCompany"
                    placeholder="请输入"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="邮箱地址:" prop="custReceiveEmail">
                  <el-input
                    maxlength="100"
                    v-model="detailInfo.custReceiveEmail"
                    placeholder="请输入"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label-width="0" prop="addressId">
              <AddressBox
                :addressList="addressList"
                :showAddressVisible="showAddressVisible"
                :checkedAddressId="detailInfo.addressId"
                @addressChangeHandle="addressChangeHandle"
                @addressEditHandle="addressEditHandle"
                @addressDeleteHandle="addressDeleteHandle"
                @toggleAddress="toggleAddress"
              />
            </el-form-item>
          </div>
          <div class="invoice_info box_distance">
            <h2 class="title required">
              发票信息
              <div class="addBtn-box" @click="invoiceAddHandle">
                <img src="@/assets/img/order/addBtn.png" />新增发票
              </div>
            </h2>
            <el-form-item label-width="0" prop="orderInvoiceId">
              <BillTabs
                :payInvoiceInfoList="payInvoiceInfoList"
                :moreInvoiceVisible="moreInvoiceVisible"
                :checkedInvoiceId="detailInfo.orderInvoiceId"
                defaultActive="first"
                @billChangeHandle="billChangeHandle"
                @invoiceEditHandle="invoiceEditHandle"
                @invoiceDeleteHandle="invoiceDeleteHandle"
                @toggleInvoice="toggleInvoice"
                @companyChange="companyChange"
              />
            </el-form-item>
          </div>
          <!-- 开票明细 开始 -->
          <div class="form-item">
            <h2 class="title required">
              订单明细：
              <el-select
                v-model="dataForm.invoiceType"
                placeholder="开票类型"
                @change="changeInvoiceType"
              >
                <el-option
                  v-for="(item, index) in options"
                  :key="index"
                  :label="item.value"
                  :value="item.code"
                >
                </el-option>
              </el-select>
              <el-button
                @click="selOrderVisible = true"
                style="margin-left: 18px"
                size="small"
                >增加</el-button
              >
            </h2>
            <el-form-item label-width="0" label="" prop="itemFormList">
              <OrderList
                @deleteHandle="deleteHandle"
                :list="dataForm.invoiceApplyOrderVoList"
              />
            </el-form-item>
          </div>
          <!-- 开票明细 结束 -->
          <!-- 开票明细 开始 -->
          <div class="form-item no-border">
            <el-form-item label-width="0" label="" prop="itemFormList">
              <GoodsList
                ref="GoodsList"
                @deleteHandle="deleteOrderItem"
                @setInvoiceOrderMoney="setInvoiceOrderMoney"
                @handlerAdd="handlerAdd"
                @confirmAddUpload="confirmAddUpload"
                :invoiceApplyOrderVoList="dataForm.invoiceApplyOrderVoList"
                :orderCodeList="orderCodeList"
                :detail="dataForm"
                :list="dataForm.invoiceApplyOrderItemVoList"
                :companyId="detailInfo.companyId"
              />
            </el-form-item>
          </div>
          <!-- 开票明细 结束 -->
        </el-form>
      </div>
    </div>
    <!-- 新增/编辑收票地址 弹窗 -->
    <EditAddressDialog
      :editAddressVisible="editAddressVisible"
      :editAddressInfo="editAddressInfo"
      :buttonLoading="buttonLoading"
      @handleClose2="handleClose2"
      @handleAddressSaved="handleAddressSaved"
    />
    <!-- 新增/编辑发票 弹窗 -->
    <EditBillDialog
      :invoiceVisible="invoiceVisible"
      :invoiceForm="invoiceForm"
      :buttonLoading="buttonLoading"
      @closeInviceHandle="closeInviceHandle"
      @invoiceSaveHandle="invoiceSaveHandle"
    />
    <!-- 删除提示 弹窗 -->
    <el-dialog
      title=""
      :visible.sync="addressDeleteVisible"
      width="30%"
      :before-close="
        () => {
          addressDeleteVisible = false
        }
      "
    >
      <span>地址删除后将无法恢复，是否确认？</span>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="addressDeleteVisible = false"
          :loading="buttonLoading"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="confirmAddDelete"
          :loading="buttonLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 选择订单  -->
    <el-dialog
      :visible.sync="selOrderVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="选择订单"
      width="1100px"
    >
      <SelOrderByCompany
        v-if="selOrderVisible"
        @cancel="selOrderVisible = false"
        :companyId="detailInfo.companyId"
        :list="dataForm.invoiceApplyOrderVoList"
        @comfirm="confirmCompanyInvoiceOrderItem"
      />
    </el-dialog>
    <!-- 选择订单明细  -->
    <el-dialog
      :visible.sync="selOrderItemVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="选择订单明细"
      width="1100px"
    >
      <SelOrderItem
        v-if="selOrderItemVisible"
        @cancel="selOrderItemVisible = false"
        :invoiceType="dataForm.invoiceType"
        :orderCodeList="orderCodeList"
        :list="dataForm.invoiceApplyOrderItemVoList"
        @confirm="confirmOrderItem"
      />
    </el-dialog>
    <!-- 附件 -->
    <el-dialog
      :visible.sync="ossIdsVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="附件"
      width="773px"
    >
      <Enclosure
        v-if="ossIdsVisible"
        :isAdd="true"
        :showUpload="true"
        :ossIds="dataForm.ossIds"
        @cancel="ossIdsVisible = false"
        @comfirm="comfirmEnclosure"
      />
    </el-dialog>
  </div>
</template>
<script>
import Enclosure from '@/components/enclosure/index.vue'
import AddressBox from '../../order/components/addressList.vue'
import BillTabs from '../../order/components/billTabs.vue'
import EditAddressDialog from '../../order/components/editAddressDialog'
import EditBillDialog from '../../order/components/editBillDialog'
import OrderList from './components/orderList.vue'
import GoodsList from './components/goodsList.vue'
import SelOrderItem from './components/selOrderItem.vue'
import SelOrderByCompany from './components/selOrderByCompany.vue'
import debounce from 'lodash/debounce'
import { add } from '@/utils/numberComputed'
import { Base64 } from 'js-base64'

export default {
  components: {
    Enclosure,
    OrderList,
    GoodsList,
    AddressBox,
    BillTabs,
    EditAddressDialog,
    EditBillDialog,
    SelOrderByCompany,
    SelOrderItem
  },
  data () {
    return {
      ossIdsVisible: false, // 附件显示
      selOrderVisible: false,
      buttonLoading: false, // 加载中
      showAddressVisible: true,
      moreInvoiceVisible: true,
      invoiceVisible: false, // 发票弹窗
      invoiceForm: {}, // 发票信息
      editAddressInfo: {}, // 编辑地址信息
      editAddressVisible: false, // 编辑地址弹窗
      addressDeleteId: null, // 删除地址ID
      addressDeleteVisible: false, // 删除地址确认弹窗
      detailInfo: {
        companyId: '',
        thirdInvoiceRemark: null, // 票面备注
        custRemark: '', // 客户备注
        orderInvoiceId: '', // 发票Id
        addressId: null, // 地址Id
        payOrderInvoice: null, // 选中的-发票信息
        payOrderAddress: null, // 选中的-地址信息
        custReceiveCompany: '',
        custReceiveEmail: ''
      },
      detailInfoRule: {
        addressId: [
          {
            required: true,
            message: '收票地址不能为空',
            trigger: 'change'
          }
        ],
        orderInvoiceId: [
          {
            required: true,
            message: '发票信息不能为空',
            trigger: 'change'
          }
        ],
        custReceiveEmail: [
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change']
          }
        ]
      },
      addressList: [], // 地址列表
      payInvoiceInfoList: [], // 发票列表
      dataForm: {
        invoiceType: '1',
        ossIds: [],
        invoiceApplyOrderVoList: [],
        invoiceApplyOrderItemVoList: []
      },
      addressType: 0,
      addressTypeList: [
        {
          code: 0,
          label: '公司地址'
        },
        {
          code: 1,
          label: '个人地址'
        }
      ],
      addressTypeCompanyId: '',
      companyAccountInfo: [],
      selOrderItemVisible: false,
      orderCodeList: []
    }
  },
  computed: {
    // 税率字典项
    options () {
      const list = window.SITE_CONFIG.dictList.INVOICE_TYPE || [] // 发票类型字典
      list.forEach((item) => {
        const index = item.value.indexOf('（')
        if (index > -1) {
          item.tax = Number(
            (
              item.value.substring(index + 1, item.value.indexOf('%')) / 100
            ).toFixed(2)
          )
          // item.taxType = item.value.substring(0, index)
        } else {
          item.tax = 0
          // item.taxType = ''
        }
      })
      return list
    },
    companyId () {
      // return this.$store.state.user.defaultCompanyId
      return this.detailInfo.companyId
    }
  },
  methods: {
    // 计算明细
    confirmCompanyInvoiceOrderItem (arr) {
      arr.forEach((item) => {
        item.invoiceReason = '1'
      })
      this.dataForm.invoiceApplyOrderVoList = arr
      this.orderCodeList = arr.map((item) => item.orderCode)
      this.changeInvoiceType(this.dataForm.invoiceType)
      this.selOrderVisible = false
    },
    // 更改发票税率字典项
    changeInvoiceType (val) {
      const invoice = this.options.find((item) => {
        return item.code === val
      })
      if (invoice) {
        // 订单明细
        this.dataForm.invoiceApplyOrderVoList.forEach((item) => {
          item.invoiceType = val // invoice.value
          item.invoiceTaxRate = invoice.tax
          // invoice.tax
        })
        // 商品明细
        this.dataForm.invoiceApplyOrderItemVoList.forEach((item) => {
          item.taxRate = invoice.tax
        })
      }
    },
    // 收票地址-地址类型切换
    addressTypeChange () {
      this.getAddressList('address')
    },
    // 收票地址-公司地址切换
    addressTypeCompanyChange () {
      this.getAddressList('address')
    },
    // 获取地址信息
    getAddressList () {
      let _this = this
      this.$http
        .post(
          `/front/webshop/personal-center/v1/user-address/list?querySelfAddressFlag=${
            this.addressType === 1
          }`,
          this.addressTypeCompanyId.split(',')
        )
        .then(({ data: { code, data } }) => {
          _this.addressList = data
          // console.log(this.addressList)
          _this.setAddress(data)
        })
    },
    // 设置收票地址 及默认选中项
    setAddress (res) {
      let _this = this
      _this.addressList = res || []
      if (_this.detailInfo.addressId) {
        let address = _this.addressList.find((item) => {
          return item.userAddressId === _this.detailInfo.addressId
        })
        if (!address) {
          _this.detailInfo.addressId = null
          _this.detailInfo.payOrderAddress = null
        } else {
          _this.detailInfo.payOrderAddress = address
        }
      }
      if (!_this.detailInfo.addressId && _this.addressList.length) {
        let address = _this.addressList.find((item) => {
          return item.defaultAddress === true
        })
        if (address) {
          _this.detailInfo.addressId = address.userAddressId
          _this.detailInfo.payOrderAddress = address
        } else {
          _this.detailInfo.addressId = _this.addressList[0].userAddressId
          _this.detailInfo.payOrderAddress = _this.addressList[0]
          // _this.addressChangeHandle(_this.addressList[0].userAddressId);
        }
      }
    },
    // 更改选中的地址
    addressChangeHandle (item) {
      this.detailInfo.addressId = item.userAddressId
      this.detailInfo.payOrderAddress = item
      if (this.asAddress) {
        this.handleAsAddress()
      }
    },
    // 编辑地址
    addressEditHandle (row) {
      this.editAddressInfo = {
        companyId: row.companyId, // 当前地址对应的公司Id
        userAddressId: row.userAddressId,
        proCityArea: [],
        address: row.address, // 地址
        orderAddress: '', // 省市区详细地址拼接
        province: '',
        city: '',
        area: '',
        receiveGoodsPerson: row.receiveGoodsPerson, // 收货人
        receiveGoodsPhone: row.receiveGoodsPhone, // 收货联系电话
        defaultAddress: row.defaultAddress, // 是否默认地址
        used: row.used // 是否可用
      }
      if (row.province) {
        this.editAddressInfo.proCityArea.push(row.province)
        if (row.city) {
          this.editAddressInfo.proCityArea.push(row.city)
          if (row.area) {
            this.editAddressInfo.proCityArea.push(row.area)
          }
        }
      }
      this.editAddressVisible = true
    },
    // 保存地址-新增/修改
    handleAddressSaved: debounce(
      function () {
        this.editAddressInfo.province = this.editAddressInfo.proCityArea[0]
        this.editAddressInfo.city = this.editAddressInfo.proCityArea[1]
        this.editAddressInfo.area = this.editAddressInfo.proCityArea[2]
        this.editAddressInfo.orderAddress =
          this.editAddressInfo.proCityArea.join('') +
          this.editAddressInfo.address
        var _this = this
        if (_this.editAddressInfo.userAddressId) {
          this.$http
            .post(
              `/front/webshop/personal-center/v1/user-address/update`,
              this.editAddressInfo
            )
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return false
              }
              _this.$message.success(res.message)
              _this.handleClose2()
              _this.getAddressList()
            })
            .catch(() => {})
        } else {
          // 如果是个人的
          let obj = {
            ...this.editAddressInfo
          }
          // 如果是企业的
          if (this.addressTypeCompanyId) {
            obj = {
              ...obj,
              isFront: true,
              companyId: this.addressTypeCompanyId,
              userId: this.$store.state.user.userId
            }
          }
          this.$http
            .put(`/front/webshop/personal-center/v1/user-address/add`, obj)
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return false
              }
              _this.$message.success(res.message)
              _this.handleClose2()
              _this.getAddressList()
            })
            .catch(() => {})
        }
      },
      1000,
      {
        leading: true,
        trailing: false
      }
    ),
    // 关闭弹窗  地址
    handleClose2 () {
      this.editAddressVisible = false
      this.editAddressInfo = {
        companyId: '', // 当前地址对应的公司Id
        userAddressId: '',
        proCityArea: [],
        address: '', // 地址
        orderAddress: '', // 省市区详细地址拼接
        province: '',
        city: '',
        area: '',
        receiveGoodsPerson: '', // 收货人
        receiveGoodsPhone: '', // 收货联系电话
        defaultAddress: false, // 是否默认地址
        used: true // 是否可用
      }
    },
    // 删除地址
    addressDeleteHandle (row) {
      this.addressDeleteId = row.userAddressId
      this.addressDeleteVisible = true
    },
    toggleAddress (flag) {
      this.showAddressVisible = !flag
    },
    // 添加地址
    addAddress () {
      this.editAddressInfo = {
        // companyId: this.params.companyId, // 当前地址对应的公司Id
        companyId: this.companyId, // 当前地址对应的公司Id
        userAddressId: '',
        proCityArea: [],
        address: '', // 地址
        orderAddress: '', // 省市区详细地址拼接
        province: '',
        city: '',
        area: '',
        receiveGoodsPerson: '', // 收货人
        receiveGoodsPhone: '', // 收货联系电话
        defaultAddress: false, // 是否默认地址
        used: true // 是否可用
      }
      this.editAddressVisible = true
    },
    // 确认删除地址
    confirmAddDelete () {
      if (!this.addressDeleteId) {
        this.addressDeleteVisible = false
        return false
      }
      this.$http
        .delete(
          `/front/webshop/personal-center/v1/user-address/${this.addressDeleteId}/delete`
        )
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.addressDeleteVisible = false
          this.getAddressList()
        })
    },
    // 获取发票信息
    getInvoicList () {
      const _this = this
      let dataForm = {
        page: 1,
        limit: 999
      }
      this.$http
        .post(
          `/front/webshop/personal-center/v1/pay-invoice-info/list-by-page`,
          dataForm
        )
        .then(
          ({
            data: {
              data: { dataList }
            }
          }) => {
            _this.payInvoiceInfoList = dataList || []
            _this.companyChange(_this.$store.state.user.company.companyId)
            if (_this.detailInfo.orderInvoiceId) {
              // 若有选中的项
              let invoiceInfo = _this.payInvoiceInfoList.find((item) => {
                return item.invoiceId === _this.detailInfo.orderInvoiceId
              })
              if (!invoiceInfo) {
                _this.detailInfo.orderInvoiceId = ''
                _this.detailInfo.payOrderInvoice = null
              } else {
                _this.detailInfo.payOrderInvoice = invoiceInfo
              }
            }
            if (
              !_this.detailInfo.orderInvoiceId &&
              _this.payInvoiceInfoList.length
            ) {
              // 若有默认项
              let invoiceInfo = _this.payInvoiceInfoList.find((item) => {
                // return item.defaultFlag === '10'
                return item.defaultFlag === '1'
              })
              if (invoiceInfo) {
                _this.detailInfo.orderInvoiceId = invoiceInfo.invoiceId
                _this.detailInfo.payOrderInvoice = invoiceInfo
              } else {
                _this.detailInfo.orderInvoiceId = ''
                _this.detailInfo.payOrderInvoice = null
              }
            }
          }
        )
        .catch()
    },
    companyChange (companyId) {
      const payInvoiceInfoList = this.payInvoiceInfoList.filter((item) => {
        return item.companyId === companyId || !companyId
      })
      if (this.detailInfo.orderInvoiceId) {
        // 若有选中的项
        let invoiceInfo = payInvoiceInfoList.find((item) => {
          return item.invoiceId === this.detailInfo.orderInvoiceId
        })
        if (!invoiceInfo) {
          this.detailInfo.orderInvoiceId = ''
          this.detailInfo.payOrderInvoice = null
        } else {
          this.detailInfo.payOrderInvoice = invoiceInfo
        }
      }
      if (!this.detailInfo.orderInvoiceId && payInvoiceInfoList.length) {
        // 若有默认项
        let invoiceInfo = payInvoiceInfoList.find((item) => {
          // return item.defaultFlag === '10'
          return item.defaultFlag === '1'
        })
        if (invoiceInfo) {
          this.detailInfo.orderInvoiceId = invoiceInfo.invoiceId
          this.detailInfo.payOrderInvoice = invoiceInfo
        } else {
          this.detailInfo.orderInvoiceId = ''
          this.detailInfo.payOrderInvoice = null
        }
      }
    },
    // 新增发票
    invoiceAddHandle () {
      this.invoiceVisible = true
      // if (this.$refs['invoiceForm']) {
      //     this.$refs['invoiceForm'].resetFields()
      // }
      this.invoiceForm = {
        flagAdd: false,
        invoiceId: '',
        invoiceObjType: '20', // 开票对象类型 10 个人 20 单位
        invoiceObjId: '20', // 开票对象10 用户id 20 公司id
        invoiceType: '20', // 开票类型10 普通发票 20 增值税发票
        companyName: '', // 开票公司名称(发票抬头)
        companyId: '', // 开票公司
        taxpayerIdentity: '', // 纳税人识别号
        companyAddress: '', // 公司地址
        companyPhone: '', // 联系电话
        openingBank: '', // 开户行
        bankAccountNo: '', // 开户行账号
        // defaultFlag: '10', //  缺省标识 10 默认 20 非默认
        defaultFlag: '1', //  默认发票标识 1 默认 0 非默认
        remarks: '',
        mailingAddress: '', // 发票邮寄地址
        consignee: '', // 收货人
        contactInformation: '' // 收货人联系方式
      }
    },
    billChangeHandle (item) {
      this.detailInfo.orderInvoiceId = item.invoiceId
      this.detailInfo.payOrderInvoice = item
    },
    // 编辑发票
    invoiceEditHandle (row) {
      this.invoiceVisible = true
      // if (this.$refs['invoiceForm']) {
      //     this.$refs['invoiceForm'].resetFields()
      // }
      this.invoiceForm = {
        // flagAdd: row.defaultFlag === '10',
        flagAdd: row.defaultFlag === '1',
        invoiceId: row.invoiceId,
        invoiceObjType: row.invoiceObjType, // 开票对象类型 10 个人 20 单位
        invoiceObjId: row.invoiceObjId, // 开票对象10 用户id 20 公司id
        invoiceType: row.invoiceType, // 开票类型10 普通发票 20 增值税发票
        companyName: row.companyName, // 开票公司名称(发票抬头)
        companyId: row.companyId, // 开票公司名称(发票抬头)
        userId: row.userId, // 用户id
        taxpayerIdentity: row.taxpayerIdentity, // 纳税人识别号
        companyAddress: row.companyAddress, // 公司地址
        companyPhone: row.companyPhone, // 联系电话
        openingBank: row.openingBank, // 开户行
        bankAccountNo: row.bankAccountNo, // 开户行账号
        defaultFlag: row.defaultFlag, //  默认发票标识
        remarks: row.remarks,
        mailingAddress: row.mailingAddress, // 发票邮寄地址
        consignee: row.consignee, // 收货人
        contactInformation: row.contactInformation // 收货人联系方式
      }
    },
    // 删除发票
    invoiceDeleteHandle (row) {
      this.$confirm('此操作将永久删除该发票?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.$http
            .post(`/front/consumer/order/payinvoice/delete`, [row.invoiceId])
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return false
              }
              this.getInvoicList()
            })
        })
        .catch(() => {})
    },
    toggleInvoice (flag) {
      this.moreInvoiceVisible = !flag
    },
    // 关闭发票
    closeInviceHandle () {
      this.invoiceVisible = false
      // this.$refs['invoiceForm'].resetFields()
    },
    // 保存发票
    invoiceSaveHandle: debounce(
      function () {
        if (this.invoiceForm.invoiceObjType === '10') {
          this.invoiceForm.invoiceObjId = ''
        } else {
          this.invoiceForm.invoiceObjId = this.companyId
        }
        // this.invoiceForm.companyId = this.companyId
        this.invoiceForm.defaultFlag = this.invoiceForm.flagAdd ? '1' : '0'
        var _this = this
        // console.log(this.invoiceForm)
        this.$http
          .post(
            `/front/webshop/personal-center/v1/pay-invoice-info/${
              _this.invoiceForm.invoiceId ? 'update' : 'save'
            }`,
            _this.invoiceForm
          )
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            _this.$message.success(res.message)
            _this.closeInviceHandle()
            _this.getInvoicList()
          })
          .catch(() => {})
      },
      1000,
      {
        leading: true,
        trailing: false
      }
    ),
    getUserInfo () {
      return (
        this.$http
          // .get('/front/consumer/usercenter/custUserCenterInfo', {
          .get('/front/webshop/personal-center/v1/cust-User-Info/get', {
            params: {
              appCode: 'WEB_SHOP',
              // appCode: 'PLANTMATE_OFFICIAL',
              companyId: this.$store.state.user.defaultCompanyId
            }
          })
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            this.userInfo = res.data.userInfo
          })
          .catch(() => {})
      )
    },
    initCompantList () {
      return this.$http
        .get(
          `/front/web-shop/org-manage/v1/all-children-company/get/${this.$store.state.user.company.companyId}?authControlFlag=true`
        )
        .then(({ data: { data } }) => {
          this.companyAccountInfo = [
            ...data.map((i) => {
              const { companyId, companyName, companyRelationType } = i
              return {
                companyId,
                companyName: `${companyName} (${companyRelationType})`
              }
            })
          ]
        })
    },
    handlerAdd () {
      this.selOrderItemVisible = true
    },
    // 确定附件
    comfirmEnclosure (ossIds) {
      this.dataForm.ossIds = ossIds
      this.ossIdsVisible = false
    },
    // 删除商品
    deleteOrderItem (index) {
      // 删除商品
      this.dataForm.invoiceApplyOrderItemVoList.splice(index, 1)
      this.computedInvoiceOrderMoney()
    },
    // 删除订单
    deleteHandle (index) {
      // 需要反应在商品上 逻辑待补充 删除该订单的所有商品
      const orderItemList = this.dataForm.invoiceApplyOrderItemVoList.filter(
        (item) => {
          return (
            item.orderCode ===
            this.dataForm.invoiceApplyOrderVoList[index].orderCode
          )
        }
      )
      if (orderItemList.length) {
        orderItemList.forEach((item) => {
          this.dataForm.invoiceApplyOrderItemVoList.splice(
            this.dataForm.invoiceApplyOrderItemVoList.findIndex((good) => {
              return (
                item.orderCode === good.orderCode &&
                good.goodsSkuId === item.goodsSkuId
              )
            }),
            1
          )
        })
      }
      // 删除订单
      this.dataForm.invoiceApplyOrderVoList.splice(index, 1)
      this.orderCodeList = this.dataForm.invoiceApplyOrderVoList.map(
        (v) => v.orderCode
      )
    },
    setOrderItem (arr) {
      const list = this.dataForm.invoiceApplyOrderItemVoList.map(
        (v) => v.orderCode + '-' + v.goodsCode
      )
      const res = []
      arr.forEach((v) => {
        const o = v.orderCode + '-' + v.goodsCode
        if (!list.includes(o)) {
          list.push(o)
          res.push(v)
        }
      })
      return [...this.dataForm.invoiceApplyOrderItemVoList, ...res]
    },
    // 根据商品明细计算订单本次开票金额
    computedInvoiceOrderMoney () {
      this.dataForm.invoiceApplyOrderVoList.forEach((orderItem) => {
        let orderTotalAmount = 0
        this.dataForm.invoiceApplyOrderItemVoList
          .filter((item) => {
            return item.orderCode === orderItem.orderCode
          })
          .forEach((item) => {
            orderTotalAmount = add(item.invoiceAmount, orderTotalAmount)
          })
        orderItem.currentInvoiceAmount = orderTotalAmount
      })
    },
    // 确定选择明细
    confirmOrderItem (data) {
      this.dataForm.invoiceApplyOrderItemVoList = this.setOrderItem(data)
      this.computedInvoiceOrderMoney()
      this.selOrderItemVisible = false
    },
    // 根据明细动态计算本次开票金额
    setInvoiceOrderMoney (arr) {
      const obj = {}
      arr.forEach((v) => {
        if (obj[v.orderCode]) {
          obj[v.orderCode] = add(v.invoiceAmount, obj[v.orderCode])
        } else {
          obj[v.orderCode] = v.invoiceAmount
        }
      })
      console.log('setInvoiceOrderMoney', obj)
      this.dataForm.invoiceApplyOrderVoList.forEach((v) => {
        if (obj[v.orderCode]) {
          v.currentInvoiceAmount = obj[v.orderCode]
        }
      })
      // this.dataForm.invoiceApplyOrderVoList = [
      //   ...this.dataForm.invoiceApplyOrderVoList
      // ]
      this.$set(
        this.dataForm,
        'invoiceApplyOrderVoList',
        this.dataForm.invoiceApplyOrderVoList
      )
      console.log(this.dataForm.invoiceApplyOrderVoList)
    },
    // 保存
    async save () {
      const goodsValid = await this.$refs.GoodsList.validate()
      this.$refs.dataForm.validate((valid) => {
        if (!goodsValid) {
          return
        }
        if (valid) {
          this.doSubmit()
        } else {
          this.setFocus()
        }
      })
    },
    // 执行提交
    doSubmit () {
      // 商品字段转换
      // 如果没有开票明细
      if (this.dataForm.invoiceApplyOrderItemVoList.length === 0) {
        this.$message.warning('请添加开票明细')
        return
      }
      if (
        this.dataForm.invoiceApplyOrderVoList.some((item) => {
          return (
            !item.currentInvoiceAmount || !Number(item.currentInvoiceAmount)
          )
        })
      ) {
        this.$message.warning('订单明细本次开票金额不能0')
        return
      }
      // 获取企业名称
      let companyName = ''
      this.companyAccountInfo.some((v) => {
        if (v.companyId === this.detailInfo.companyId) {
          companyName = v.companyName
        }
      })
      const obj = {
        ...this.dataForm,
        companyId: this.detailInfo.companyId,
        companyName,
        thirdInvoiceRemark: this.detailInfo.thirdInvoiceRemark, // 票面备注
        custRemark: this.detailInfo.custRemark, // 客户备注
        custReceiveCompany: this.detailInfo.custReceiveCompany,
        custReceiveEmail: this.detailInfo.custReceiveEmail
      }
      const payOrderInvoice = this.detailInfo.payOrderInvoice || {} // 发票信息
      obj.clientId = payOrderInvoice.companyId
      obj.clientUnifiedCode = payOrderInvoice.taxpayerIdentity // 纳税人识别号
      obj.clientName = payOrderInvoice.companyName
      obj.clientBank = payOrderInvoice.openingBank
      obj.clientBankAccount = payOrderInvoice.bankAccountNo
      obj.clientAddress = payOrderInvoice.companyAddress
      obj.clientPhone = payOrderInvoice.companyPhone
      // 发票地址 开始
      const payOrderAddressInvoice = this.detailInfo.payOrderAddress // 发票地址
      if (payOrderAddressInvoice) {
        obj.receiveAddress = payOrderAddressInvoice.address
        obj.receiveArea = payOrderAddressInvoice.area
        obj.receiveCity = payOrderAddressInvoice.city
        obj.receiveProvince = payOrderAddressInvoice.province
        obj.receiveGoodsPerson = payOrderAddressInvoice.receiveGoodsPerson
        obj.receiveGoodsPhone = payOrderAddressInvoice.receiveGoodsPhone
        obj.receiveUserAddressId = payOrderAddressInvoice.addressId
      }
      // 获取附件ids
      obj.ossIds = this.dataForm.ossIds.map((item) => item.aliOssId)
      const loading = this.$loading({
        lock: true,
        text: '销售发票申请提交中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      })
      this.$http
        .post('/front/oms/shopping/invoiceApply/save', obj)
        .then(({ data: res }) => {
          loading.close()
          if (res.code !== 0) {
            return
          }
          this.$message.success(res.message)
          this.$router.push({
            path: '/personalCenter/order-invoice-detail',
            query: {
              invoiceApplyId: Base64.encode(res.data)
            }
          })
        })
        .catch(() => {
          loading.close()
        })
    },
    // 如果没有填写就提示
    setFocus () {
      this.$nextTick(() => {
        const isError = document.getElementsByClassName('is-error')
        isError[0].querySelector('input') &&
          isError[0].querySelector('input').focus()
      })
      this.$message.warning('存在必填项填写有误，请检查填写')
    },
    confirmAddUpload (arr) {
      //  更新商品明细
      const m = new Map()
      ;[...this.dataForm.invoiceApplyOrderItemVoList, ...arr].forEach((i) => {
        m.set(`${i.orderCode}_${i.goodsCode}`, i)
      })
      this.dataForm.invoiceApplyOrderItemVoList = [...m.values()]
      const orderCodeList = this.dataForm.invoiceApplyOrderItemVoList.map(
        i => i.orderCode
      )
      this.getOrderList(orderCodeList)
    },
    getOrderList (orderCodeList) {
      this.$http
        .post('/front/oms/shopping/invoiceApply/order/list', {
          companyId: this.companyId,
          orderCodeList,
          page: 1,
          limit: 10000 // 默认整页全部
        })
        .then(({ data }) => {
          const { records } = data.data
          const m = new Map()
          ;[...this.dataForm.invoiceApplyOrderVoList, ...records].forEach(i => {
            m.set(i.orderCode, i)
          })
          const invoice = this.options.find(item => {
            return item.code === this.dataForm.invoiceType
          })
          this.dataForm.invoiceApplyOrderVoList = [...m.values()].map(i => {
            return {
              ...i,
              invoiceType: this.dataForm.invoiceType,
              invoiceTaxRate: invoice.tax,
              invoiceReason: '1' // 默认销售开票
            }
          })
          this.setInvoiceOrderMoney(this.dataForm.invoiceApplyOrderItemVoList)
        })
    },
    setDefaultInfo (orderCode) {
      const obj = {
        orderCodeList: [orderCode],
        companyId: this.detailInfo.companyId,
        page: 1,
        limit: 20
      }
      this.$http
        .post('/front/oms/shopping/invoiceApply/order/list', obj)
        .then(({ data: res }) => {
          if (res.code === 0 && res.data && res.data.records) {
            this.confirmCompanyInvoiceOrderItem(res.data.records)
            this.getOrderItem(orderCode)
          }
        })
    },
    getOrderItem (orderCode) {
      const obj2 = { orderCodeList: [orderCode], invoiceType: '1' }
      this.$http
        .post('/front/oms/shopping/invoiceApply/orderItem/list', obj2)
        .then(({ data: res }) => {
          if (res.code === 0 && res.data) {
            this.confirmOrderItem(res.data)
          }
        })
    }
  },
  created () {
    this.initCompantList()
  },
  mounted () {
    this.detailInfo.companyId = this.$store.state.user.company.companyId
    this.addressTypeCompanyId = this.$store.state.user.company.companyId
    // 如果是去开票 回显订单跟明细
    if (this.$route.query.orderCode) {
      this.setDefaultInfo(this.$route.query.orderCode)
    }
    this.getUserInfo()
    this.getAddressList()
    this.getInvoicList()
  }
}
</script>
<style lang="scss">
.spare_add_page {
  height: 100%;
}
.spare_add_page .page_detail {
  background: #fff;
  padding: 30px;
  height: 100%;
  // width: 1190px;
  // margin: 0 auto;
  width: 100%;
  .box_distance {
    margin-top: 20px;
  }
  .form-wrap {
    flex: 1;
    overflow: auto;
  }
  .addBtn-box {
    font-size: 14px;
    height: 20px;
    line-height: 20px;
    // color: #3d88d4;
    color: #028df9;
    float: right;
    cursor: pointer;
    img {
      width: 16px;
      height: 16px;
      display: block;
      float: left;
      margin: 2px 6px;
    }
  }
}
.top-info {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 12px;
  h2 {
    font-size: 18px;
    margin: 0 0 6px 0;
  }
}
.ossIdsLen {
  margin: -3px 12px 0 12px;
}
.title {
  font-size: 14px;
  &::before {
    content: '*';
    color: transparent;
  }
  &.required::before {
    color: #f00;
  }
  &.required > .tip {
    font-size: 10px;
    font-weight: normal;
  }
}
</style>
